import { h, Component } from 'preact'
import Header from '../header'
import ButtonControl from '../button-control'
import Icon from '../assets'
import AccordionPanel from '../panel/AccordionPanel'
import { PanelHeaderWithIcon } from '../registration-rules/PanelItems'

type Props = {
}

type State = {
}

const dataExportPanel = {
  heading: 'Analytics',
  title: <PanelHeaderWithIcon title='Data export' icon='downloadCloud' customClass='panel-header-container' />,
  body: <a href='/ideas/export' target='_blank' class='ideation-ideas-export'><ButtonControl
    newStyle
    size='medium'
    title='Export all ideas in CSV'
    variant='brand'
  /></a>
}

export class Ideation extends Component<Props, State> {
  render () {
    return (
      <div className='group-overview-page'>
        <Header
          title='Ideation'
          disableSaveButton
          disableCancelButton
          customButtons={[
            <a href='/idea/overview' target='_blank'>
              <ButtonControl
                title={<div class='ideation-overview-link'>Go to ideation overview page<Icon icon={'openInNew'} width={16} height={16} /></div>}
                variant='secondary'
                newStyle
                size='medium'
              />
            </a>
          ]}
        />
        <AccordionPanel
          panels={[dataExportPanel]}
        />
      </div>
    )
  }
}

export default Ideation
